<script setup lang="ts">
definePageMeta({
  title: 'pages.legalNotices.seo.title',
  description: 'pages.legalNotices.seo.description',
});
</script>

<template>
  <div>
    <LegalNotices />
  </div>
</template>
